import { SlideKind } from '@duke-hq/svc-api-db';

export type IncompleteReason = 'FORM_NO_FIELDS' | 'QUESTION_GROUP_NO_QUESTIONS';

export type IncompleteSlide = {
  id: string;
  title: string;
  reason: IncompleteReason;
};

type SlideForIncompleteCheck = {
  id: string;
  title: string;
  kind?: string | null;
  sections?: ReadonlyArray<{ fields: ReadonlyArray<unknown> }>;
  questions?: ReadonlyArray<unknown>;
};

// Prisma reads return the schema enum member name (e.g. 'FORM'), but the
// getSlides query remaps each slide to `SlideKind.FORM`, which the generated
// client exports as the @map'd database value (e.g. 'UnitAssessmentForm').
// Callers may pass either, so accept both.
const FORM_KINDS: ReadonlyArray<string> = ['FORM', SlideKind.FORM];
const QUESTION_GROUP_KINDS: ReadonlyArray<string> = ['QUESTION_GROUP', SlideKind.QUESTION_GROUP];

export function findIncompleteSlides(
  slides: ReadonlyArray<SlideForIncompleteCheck>,
): IncompleteSlide[] {
  const result: IncompleteSlide[] = [];

  for (const slide of slides) {
    const kind = slide.kind ?? '';
    if (FORM_KINDS.includes(kind)) {
      const sections = slide.sections ?? [];
      const hasAnyField = sections.some((section) => section.fields.length > 0);
      if (!hasAnyField) {
        result.push({ id: slide.id, title: slide.title, reason: 'FORM_NO_FIELDS' });
      }
    } else if (QUESTION_GROUP_KINDS.includes(kind)) {
      const questions = slide.questions ?? [];
      if (questions.length === 0) {
        result.push({
          id: slide.id,
          title: slide.title,
          reason: 'QUESTION_GROUP_NO_QUESTIONS',
        });
      }
    }
  }

  return result;
}
